
import React, {useEffect, useState} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import AOS from 'aos';
import {connect} from 'react-redux';
import {addLoftyUser, deleteLoftytoken} from './actions/auth.actions';
import { loftySendVisitProject } from './util/visitsprojects';

// pages
import nosotrosccx93 from './pages/nosotrosccx93/nosotrosccx93'
import homeejie4 from './pages/homeejie4/homeejie4'
import sociokegz7g from './pages/sociokegz7g/sociokegz7g'
import publicidadfp8m5i from './pages/publicidadfp8m5i/publicidadfp8m5i'
import terminos3qcv3i from './pages/terminos3qcv3i/terminos3qcv3i'
import eliminary4z80k from './pages/eliminary4z80k/eliminary4z80k'
import preguntasis9pnj from './pages/preguntasis9pnj/preguntasis9pnj'
import pronto40t8o from './pages/pronto40t8o/pronto40t8o'
import contactanos75bdbl from './pages/contactanos75bdbl/contactanos75bdbl'
import errorqmpd1 from './pages/errorqmpd1/errorqmpd1'


// css
import './App.css';
import 'aos/dist/aos.css';

AOS.init();

function initSwiper() {
  // eslint-disable-next-line no-undef
  const swiper = new Swiper('.mySwiper', {
    spaceBetween: 30,
    centeredSlides: true,
    autoplay: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  // console.log('swiper :>> ', swiper);
}

const App = ({loftytoken, addLoftyUserApp, deleteLoftytokenApp}) => {

  // agregando iniciación para el Swipper
  useEffect(() => {
    setTimeout(() => {
      initSwiper();
    }, 2000);
  }, []);

  useEffect(() => { loftySendVisitProject() }, []);

  

  return (
    <Router>
      <Switch>
			<Route exact path="/nosotros" component={nosotrosccx93} />
			<Route exact path="/" component={homeejie4} />
			<Route exact path="/socio_motorista" component={sociokegz7g} />
			<Route exact path="/publicidad" component={publicidadfp8m5i} />
			<Route exact path="/terminos_politicas" component={terminos3qcv3i} />
			<Route exact path="/eliminar_cuenta" component={eliminary4z80k} />
			<Route exact path="/preguntas_respuestas" component={preguntasis9pnj} />
			<Route exact path="/pronto" component={pronto40t8o} />
			<Route exact path="/contactanos" component={contactanos75bdbl} />
			<Route exact path="*" component={errorqmpd1} />

      </Switch>
    </Router>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
  addLoftyUserApp: (user) => dispatch(addLoftyUser(user)),
  deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);

